import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import moment from 'moment';

import { TimeService, utils } from '@bayclubs/utils';

import { ICalendarDay } from '../../models/calendar.model';
import { CalendarService } from '../../services/calendar.service';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerMultiselectComponent),
    multi: true,
};

@Component({
    selector: 'app-date-picker-multiselect',
    templateUrl: './date-picker-multiselect.component.html',
    styleUrls: ['./date-picker-multiselect.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class DatePickerMultiselectComponent implements OnInit, ControlValueAccessor {
    //reactive forms
    onChange = (dates: utils.BcDate[]) => {};
    onTouched = () => {};

    registerOnChange(fn: (dates: utils.BcDate[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(dates: utils.BcDate[]): void {
        if (dates) {
            this.selectedInner = dates.map(x => moment(x.value)).filter(x => x.isValid());
            this.onChange(this.value);
        }
    }
    get value(): utils.BcDate[] {
        const v = this.selectedInner.filter(x => x.isValid()).map(x => this.time.toBcDate(x));
        return v;
    }

    //reactive forms end

    //input
    @Input() public readonly: boolean;

    @Input() public canSelectPastDates: boolean;

    @Input() public selectColor: string;
    //end input

    public date: moment.Moment;
    public days: Array<ICalendarDay> = null;

    private selectedInner: moment.Moment[] = [];

    constructor(private time: TimeService, private calendar: CalendarService) {}

    ngOnInit() {
        this.date = this.calendar.now();

        this.setupDays();
    }

    public get year() {
        return this.date.format('YYYY');
    }

    public get month() {
        return this.date.format('MMMM');
    }

    public onPreviousMonth(): void {
        if (this.readonly) {
            return;
        }
        this.date = this.calendar.proviousMonth(this.date);
        this.setupDays();
    }

    public onNextMonth(): void {
        if (this.readonly) {
            return;
        }

        this.date = this.calendar.nextMonth(this.date);
        this.setupDays();
    }

    public onSelectDay(day: ICalendarDay) {
        if (this.readonly || this.cannotSelectPast(day)) {
            return;
        }

        var existing = this.indexOfDate(day);
        if (existing > -1) {
            this.selectedInner.splice(existing, 1);
        } else {
            this.selectedInner.push(day.date);
        }

        this.onChange(this.value);
    }

    public isSelected(day: ICalendarDay) {
        if (!this.selectedInner) {
            return false;
        }
        var thesame = this.indexOfDate(day);
        return thesame >= 0;
    }

    public indexOfDate(day: ICalendarDay) {
        var theSame = this.selectedInner.findIndex(x => this.calendar.isTheSameDay(x, day.date));
        return theSame;
    }

    public cannotSelectPast(day: ICalendarDay) {
        if (this.canSelectPastDates) return false;

        return this.calendar.isInThePast(day.date);
    }

    private setupDays() {
        this.days = this.calendar.setupDays(this.date);
    }
}
